import { Link } from "react-router-dom";

export function LogoMark({ size = 30 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <defs>
                <linearGradient id="sp-lgrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#F59E0B" />
                    <stop offset="1" stopColor="#B45309" />
                </linearGradient>
            </defs>
            <rect width="64" height="64" rx="14" fill="url(#sp-lgrad)" />
            <path d="M37 8 L17 38 H28 L23 56 L47 26 H36 Z" fill="#0B0F17" />
        </svg>
    );
}

export default function Logo({ compact = false }) {
    return (
        <Link
            data-testid="nav-logo-link"
            to="/"
            className="group flex items-center gap-3"
            aria-label="Services & Prestations Ltd. — Home"
        >
            <span className="transition-transform duration-300 group-hover:rotate-6">
                <LogoMark />
            </span>
            {!compact && (
                <span className="leading-none">
                    <span className="block font-display text-[15px] font-bold tracking-tight text-white transition-colors group-hover:text-amber-400">
                        SERVICES &amp; PRESTATIONS
                    </span>
                    <span className="mt-1 block font-mono text-[10px] tracking-[0.32em] text-slate-400">
                        LTD · MULTI-TRADE
                    </span>
                </span>
            )}
        </Link>
    );
}
